import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleRecapcha = async () => {
    try {
      if (!executeRecaptcha) {
        return;
      }

      const token = await executeRecaptcha('search');
      if (!token) {
        return;
      }
      return token;
    } catch (err) {
      return;
    }
  };

  return { handleRecapcha, isRecaptchaReady: !!executeRecaptcha };
};

export default useRecaptcha;
